import { RagIndex } from './indexesEnum';

export enum Section {
  Jurisprudence = 'jurisprudence',
  Default = 'default',
  Doctrine = 'doctrine',
  BestPractices = 'best_practices',
  AuthorsContext = 'authors_context',
  OurConsultations = 'our_consultations',
  BestDossiers = 'best_dossiers',
  QuestionAnswers = 'question_answers'
}

const DEFAULT_SECTION_PRIORITY: Section[] = [
  Section.Default,
  Section.Jurisprudence,
  Section.Doctrine,
  Section.AuthorsContext,
  Section.BestPractices,
  Section.OurConsultations,
  Section.BestDossiers,
  Section.QuestionAnswers
];

const SECTION_PRIORITY_BY_INDEX: Partial<Record<RagIndex, Section[]>> = {
  [RagIndex.NAW]: [
    Section.Default,
    Section.Jurisprudence,
    Section.Doctrine,
    Section.AuthorsContext,
    Section.BestPractices,
    Section.OurConsultations,
    Section.BestDossiers,
    Section.QuestionAnswers
  ],
  [RagIndex.CissContable]: [
    Section.Default,
    Section.Doctrine,
    Section.Jurisprudence,
    Section.QuestionAnswers
  ],
  [RagIndex.CissFiscal]: [
    Section.Default,
    Section.Doctrine,
    Section.Jurisprudence,
    Section.QuestionAnswers
  ],
  [RagIndex.CissLaboral]: [
    Section.Default,
    Section.Doctrine,
    Section.Jurisprudence,
    Section.QuestionAnswers
  ],
  [RagIndex.ECAY]: [
    Section.Default,
    Section.OurConsultations,
    Section.AuthorsContext,
    Section.Jurisprudence,
    Section.Doctrine,
    Section.BestDossiers
  ]
};

export function getSectionPriority(index?: RagIndex): Section[] {
  if (index && SECTION_PRIORITY_BY_INDEX[index]) {
    return SECTION_PRIORITY_BY_INDEX[index]!;
  }
  return DEFAULT_SECTION_PRIORITY;
}
